import { atomFamily } from "recoil";

export const downloadCSUState = atomFamily<boolean, string | null>({
  key: "DownloadCSUState",
  default: false,
});

export const downloadConditionsErrorState = atomFamily<boolean, string | null>({
  key: "DownloadConditionsErrorState",
  default: false,
});
